import { render, staticRenderFns } from "./RawProductScrapsSection.vue?vue&type=template&id=077340e0&scoped=true&"
import script from "./RawProductScrapsSection.vue?vue&type=script&lang=js&"
export * from "./RawProductScrapsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077340e0",
  null
  
)

export default component.exports